import {
  ShaderMaterial,
  TextureLoader,
  RepeatWrapping,
  ShaderChunk
} from "three";


const loader = new TextureLoader();
const grassTexture = loader.load('/assets/terrain1.jpg');
const sandTexture = loader.load('/assets/terrain2.jpg');
// 纹理平铺和清晰度
grassTexture.wrapS = grassTexture.wrapT = RepeatWrapping;
sandTexture.wrapS = sandTexture.wrapT = RepeatWrapping;

const uniforms = {
  grassTexture: { value: grassTexture },
  sandTexture: { value: sandTexture },
  minHeight: { value: -1.0 },   // 沙地阈值
  maxHeight: { value: -0.7 }   // 草地阈值
};

const vertexShader = `
    varying float vHeight;
    varying vec2 vUv;
    ${ShaderChunk.logdepthbuf_pars_vertex}
    bool isPerspectiveMatrix(mat4){
      return true;
    }
    void main() {
        vHeight = position.y; 
        vUv = uv;
        gl_Position = projectionMatrix * modelViewMatrix * vec4(position,1.0);
        ${ShaderChunk.logdepthbuf_vertex}
    }
`;

const fragmentShader = `
  uniform sampler2D grassTexture;
    uniform sampler2D sandTexture;
    uniform float minHeight;
    uniform float maxHeight;
    varying float vHeight;
    varying vec2 vUv;
    ${ShaderChunk.logdepthbuf_pars_fragment}
    void main() {
      float t = clamp((vHeight - minHeight) / (maxHeight - minHeight), 0.0, 1.0);
      vec4 sand = texture2D(sandTexture, vUv);
      vec4 grass = texture2D(grassTexture, vUv);
      gl_FragColor = mix(sand, grass, t);
      ${ShaderChunk.logdepthbuf_fragment}
    }
`;

export const terrainMaterial = new ShaderMaterial({
  uniforms,
  vertexShader,
  fragmentShader
});
